export interface Product {
  gtin: string;
  name: string;
}

export const products: Product[] = [
  { gtin: "5070003067107", name: "BrainMatter Cognitive" },
  { gtin: "5070003067152", name: "BrainMatter Calm" },
  { gtin: "5070003067121", name: "WIRED 3-IN-1 Performance Fuel (Berry Fusion)" },
  { gtin: "5070003067138", name: "WIRED 3-IN-1 Performance Fuel (Melon Ice)" },
  { gtin: "5070003067145", name: "WIRED 3-IN-1 Performance Fuel (Citrus Lime)" },
  { gtin: "5070003067176", name: "WIRED 3-IN-1 Performance Fuel Discovery Pack" },
  { gtin: "5070003067169", name: "WIRED Pure Creatine Monohydrate" },
];

export const WHATSAPP_NUMBER = "447824883212";

export function getProductByGtin(gtin: string): Product | undefined {
  return products.find((p) => p.gtin === gtin);
}

export function getWhatsAppUrl(product: Product): string {
  const message = `Hi, I'd like to start my journey with ${product.name} and would love personalised guidance on how to get the most out of my product.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}
